export default "__VITE_PUBLIC_ASSET__cf01e034__"